/* ============
 * Mutation types for the category module
 * ============
 *
 * The mutation types that are available
 * on the category module.
 */
import keyMirror from 'key-mirror';

export default keyMirror({
  FETCH_CATEGORY_LIST: null,
  FETCH_CATEGORY_LIST_SUCCESS: null,
  FETCH_CATEGORY_LIST_FAIL: null
});
